import React from "react";
import { Container, CenterDiv, /* LogoImage */ LogoCanto } from "./styles.js";
import RegisterView from "../../views/Register/index.jsx";
/* import logo from '../../assets/LogoPos2.png';
 */
import logoCanto from "../../assets/logoCanto.png";

function Register() {
  return (
    <Container>
      <CenterDiv>
        <LogoCanto src={logoCanto} alt="Logo Cantoneira" />

        <h2>Primeira etapa!</h2>
        <h4>Preencha os campos abaixo com as suas informações</h4>
        <RegisterView />

        {/*  <LogoImage src={logo} alt="Logo CEDAP" /> */}
      </CenterDiv>
    </Container>
  );
}

export default Register;
